/**
 * Joins class names together, filtering out falsy values.
 * Accepts strings, false, null, or undefined.
 *
 * @param entries - Class names or falsy values
 * @returns A space-separated string of valid class names, or undefined if none
 */
export const classes = (...entries: Array<string | false | null | undefined>): string | undefined => {
    const res = entries.filter(Boolean) as string[];
    return res.length ? res.join(' ') : '';
};
